export const blockContent = [
  {
    heroTitle: "Block Management Services",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "Residents Management companies & Freeholders",
    introText: `
AquaHeat is experienced in servicing and maintaining occupied properties whilst delivering maintenance, compliance, general refurbishment and quoted project works for plumbing and gas work.`,
  },
  {
    contLeftTitle: "Residential Block Maintenance",
    contLeftText: `Our highly trained team know how to conduct themselves in a timely, discreet manner to offer you peace of mind 24 hrs a day, 365 days a year. `,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643106318/AquaHeat/new%20images/gary-butterfield-sVE2PKeCnVQ-unsplash_uhoqqq.webp`,
  },
  {
    contRightTitle: "Transparent Communication",
    contRightText: `All work is carried out with regular communication and updates provided to your management company & Freeholders where necessary.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643106521/AquaHeat/new%20images/Screenshot_2022-01-25_at_09.29.31_afv2xj.webp`,
  },
  {
    callToActionTitle: "For Block Management Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
